<div id="livebetsoccer_div" onscroll="Scroll_Table()" style="overflow-x: hidden">
  <div class="ui table LiveBets_Tables" [ngStyle]="fixtureStyles.tableNoNBorder">

    <virtual-scroller #scroll [items]="this.fullmatch | async"
                      [enableUnequalChildrenSizes]="true"
                      [bufferAmount]="_bufferAmount"
                      [ngStyle]="styles.virtualScroll"
                      [scrollAnimationTime]="0"
                      [scrollDebounceTime]="10"
                      [stripedTable]="true"
                      [useMarginInsteadOfTranslate]="true"
                      [compareItems]="compareItems"
                      class="{{ isScoreBox ? 'ScrollBar' : ''}}"
    >
      <div
        *ngFor="let item of scroll.viewPortItems;let i = index;"
        class="uniqueRow {{item.TypeOfList}} color_{{item.IndexOdd}}"
        [fixtureItem]="item"
        [indexOfItem]="i"
        [IndexOdd]="item.IndexOdd"
        [typeOfList]="item.TypeOfList"
        [isScoreBox]="isScoreBox"
        [isExpandShow]="expandShowMatchId === item.MatchId"
        (expandNotifier)="expandNotifierHandler($event,i)"
        
      ></div>

    </virtual-scroller>


  </div>

</div>


<!--
    <img
      *ngIf="this.tournamentsService._liveFixtureListSoccer?.length == 0 && this.tournamentsService.terminalFixtureList?.length == 0"
      style="width:100%" src="../../../Images/fixturebackground/futbol_null.png"/>

-->

<style>
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
</style>

